module.exports = __webpack_public_path__ + "img/途牛_04.cfdf9d27.jpg";